// extracted by mini-css-extract-plugin
export default {"wrapper":"kU-z"};